import { useNavigate } from "react-router-dom";
import "./cardcustomXs.css";
const CardCustomXs = ({ spectacle }) => {
	const history = useNavigate();
	const linkToAgenda = () => {
		window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
		history(`/spectacles/detail/${spectacle.id}`);
	};
	return (
		<a href="#top">
			<div
				onClick={linkToAgenda}
				className="cardXs text-white card-has-bg click-col"
				style={{
					backgroundImage: `url(${spectacle.affiche})`,
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
				}}
			>
				<div className="card-img-overlay d-flex flex-column">
					<div className="card-body">
						<h4 className="card-title titleCardCustom mt-0 ">
							{spectacle.titre}
						</h4>
						<small>
							<p>{spectacle.mini_description}</p>
						</small>
					</div>
				</div>
			</div>
		</a>
	);
};

export default CardCustomXs;
